import React from "react";
import { node, oneOf, string } from "prop-types";
import Section from "../Section";
import { Col, Container, Row } from "../Grid";
import { classes } from "../utils/classes";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";
import { sxClassName, sxProps, sxPropTypes, textAlignPropTypes } from "../props/sx";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";

const Hero = ({
	align = "center",
	children,
	color = "black--02",
	utility = { ...utilityProps },
	sx = { ...sxProps },
	spacing = { ...spacingProps },
	className = "",
	backgroundImage,
}) => {
	return (
		<Section
			className={classes(
				"section-hero",
				align && `section-hero-text-${align}`,
				color && `section-hero-color-${color}`,
				`${backgroundImage ? "section-hero-custom-background" : ""}`,
				...utilityClassName(utility),
				...sxClassName(sx),
				...spacingClassName(spacing),
				className,
			)}
			style={{ ...(backgroundImage && { backgroundImage: `url(${backgroundImage})` }) }}
		>
			<Container>
				<Row>
					<Col>{children}</Col>
				</Row>
			</Container>
		</Section>
	);
};

Hero.propTypes = {
	align: textAlignPropTypes,
	className: string,
	children: node.isRequired,
	color: oneOf([
		"1",
		"1--light",
		"2",
		"3",
		"4",
		"5",
		"6",
		"white",
		"black--02",
		"transparent",
		"gradient",
	]),
	backgroundImage: string,
	utility: utilityPropTypes,
	sx: sxPropTypes,
	spacing: spacingPropTypes,
};

export default Hero;
